import { render, staticRenderFns } from "./CommunicationsStandardTable.vue?vue&type=template&id=8e597e44"
import script from "./CommunicationsStandardTable.vue?vue&type=script&lang=js"
export * from "./CommunicationsStandardTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports